var _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M864.3,409.7c1.4-10.7,3.2-21.2,3.2-32.2c0-135.3-109.6-245-245-245c-80,0-150.4,38.9-195.1,98.3c-16.1-3.9-32.7-6.5-49.9-6.5c-118.4,0-214.4,95.9-214.4,214.4c0,3.3,0.8,6.3,1,9.7C75.3,474.6,10,555.8,10,653.1c0,118.4,95.9,214.4,214.4,214.4H745c135.4,0,245-109.6,245-245C990,530.7,939,451.7,864.3,409.7z M561.3,561.2V745H438.8V561.2H316.3L500,377.5l183.8,183.7H561.3L561.3,561.2z",
    fill: "#151935"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.937d56bc.svg";
export { ForwardRef as ReactComponent };